import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFavorites } from "../context/FavoritesContext";
import MobileBottomBar from "../components/MobileBottomBar";
import ProductQuickViewModal from "../components/ProductQuickViewModal";
import CartQtyControl from "../components/CartQtyControl";
import { Lock, Heart, Eye } from "lucide-react";
import { getImageUrl } from "../utils/getImageUrl";

export default function Favorites() {
  const navigate = useNavigate();
  const { favorites } = useFavorites();
  const [quickView, setQuickView] = useState(null);

  const isLoggedIn = !!localStorage.getItem("token");

  if (!isLoggedIn) {
    return (
      <div className="min-h-screen bg-black pt-6 max-w-6xl mx-auto px-6 pb-20">
        <button
          onClick={() => navigate(-1)}
          className="mb-6 flex items-center gap-2 text-supernova-500 hover:text-supernova-400
                   transition font-semibold"
        >
          <span className="text-xl">←</span> Volver
        </button>

        <Lock size={60} className="text-gray-500 mb-4" />
        <h2 className="text-2xl font-bold text-white mb-2">
          Inicia sesión para ver tus favoritos
        </h2>
        <p className="text-gray-400 mb-6 max-w-xs">
          Debes estar registrado para guardar y ver tus productos favoritos.
        </p>

        <button
          onClick={() => navigate("/login")}
          className="bg-supernova-500 hover:bg-supernova-600 text-white px-6 py-3 rounded-xl font-semibold"
        >
          Iniciar sesión
        </button>

        <MobileBottomBar />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black pt-6 max-w-6xl mx-auto px-6 pb-20">
      <button
        onClick={() => navigate(-1)}
        className="mb-6 flex items-center gap-2 text-supernova-500 hover:text-supernova-400
                   transition font-semibold"
      >
        <span className="text-xl">←</span> Volver
      </button>
      <h1 className="text-3xl font-bold text-center mb-8 text-white">Tus favoritos</h1>

      {favorites.length === 0 ? (
        <div className="text-center mt-20 text-gray-400">
          <Heart size={60} className="mx-auto text-gray-600 mb-4" />
          <p>No tienes productos en favoritos todavía.</p>
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {favorites.map((p) => (
            <div
              key={p._id}
              className="bg-zinc-900 rounded-xl border border-zinc-800 p-4 hover:border-zinc-600 transition"
            >
              <img
                src={getImageUrl(p.images?.[0])}
                alt={p.title}
                onClick={() => navigate(`/product/${p._id}`)}
                className="w-full h-48 object-cover rounded-xl mb-4 cursor-pointer"
              />

              <h3 className="font-semibold text-lg text-white">{p.title}</h3>
              <p className="text-supernova-500 font-bold text-xl mb-3">
                ${p.price.toLocaleString("es-CO")}
              </p>

              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => setQuickView(p)}
                  className="p-2.5 rounded-xl border border-zinc-700 bg-zinc-800 hover:bg-zinc-700 transition shrink-0"
                  title="Ver descripción"
                >
                  <Eye size={16} className="text-gray-300" />
                </button>
                <CartQtyControl product={p} size="md" tone="dark" addClassName="bg-supernova-500 hover:bg-supernova-600 text-white" />
              </div>
            </div>
          ))}
        </div>
      )}

      <MobileBottomBar />

      {quickView && (
        <ProductQuickViewModal product={quickView} onClose={() => setQuickView(null)} />
      )}
    </div>
  );
}
